import React from 'react';
import './css/popupstyle.css';
import DeleteIcon from '../components/css/dark/img/delete.svg';
import CreateDashboardIcon from '../components/css/dark/img/create-dashboard.svg';
import ResendPassword from '../components/css/dark/img/change-passowrd.svg';
import Error from '../components/css/dark/img/error.svg';
import Success from '../components/css/dark/img/success.svg';
import CreateDashboardPopup from '../components/CreateDashboardPopup';
import $ from 'jquery';
import ConfirmDeleteAdminPopup from '../components/ConfirmDeleteAdminPopup';
import AddUserPopup from '../components/addUserPopup';
import User from '../components/css/dark/img/user.svg';

class ManageUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            wname: this.props.wholesaler_name,
            userdata: JSON.parse(localStorage.getItem('user')),
            DeletePopup: false,
            CreateDashboardPopup: false,
            ResendPasswordPopup: false,
            AddUserPopup: false,
            DeleteSection: true,
            DashboardSection: true,
            WholesalerName: '',
            ResendPasswordSection: true,
            filterId: '',
            UserList: [],
            UserList_Temp: [],
            loader: true,
            containerHide: false,
            UserName: '',
            UserEmail: '',
            UserId: '',
            OpStatus: false,
            SortBy: ''
        };
        this.CloseResendPopup = this.CloseResendPopup.bind(this);
        this.CloseCreatPopup = this.CloseCreatPopup.bind(this);

    }
    componentDidMount() {
        this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.userrole);
        $('.configure-close').on('click', function () {
            $(".configure-error").animate({
                right: -450 + 'px'
            }, 1000);
        });

    }
    componentDidUpdate() {
        if (this.state.UserList == [] || this.state.UserList.length == 0) {
            this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.userrole);
        }
    }
    handleSlideToggle = e => {
        $(e.target).parent().parent().siblings().find('.toggle-Content').slideUp();
        $(e.target).parent().parent().siblings().find('.plus-sign').removeClass('expand');
        $(e.target).parent().next().slideToggle();
        $(e.target).toggleClass('expand');
    }
    GetDistributorList(roleName, roleType) {
        try {
            $('.nav_in').html('');
            $('.selectbox select').html('');
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ roleName, roleType })
            };
            return fetch(`/api/admin/Wh_DashList`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {

                        if (this.state.SortBy == 'withdashboard') {
                            var With_D_List = apidata.filter(function (e1) {
                                return e1.dashid != "0";
                            });
                            this.setState({
                                UserList: With_D_List, SortBy: 'withdashboard', loader: false, containerHide: true, UserList_Temp: JSON.parse(JSON.stringify(apidata))
                            });
                        }
                        else if (this.state.SortBy == 'withoutdashboard') {
                            var Without_D_List = apidata.filter(function (e1) {
                                return e1.dashid == "0";
                            });
                            this.setState({
                                UserList: Without_D_List, SortBy: 'withoutdashboard', loader: false, containerHide: true, UserList_Temp: JSON.parse(JSON.stringify(apidata))
                            });
                        }
                        else {
                            this.setState({ UserList: apidata, SortBy: 'all', loader: false, containerHide: true, UserList_Temp: JSON.parse(JSON.stringify(apidata)) });
                        }
                    }
                    catch (error) {
                    }
                    var rowsShown = 12;
                    var maxnoshow = 6;

                    if ($(window).width() < 1900) {
                        rowsShown = 5;
                    }
                    if ($(window).width() < 900) {
                        rowsShown = 4;
                    }

                    // first tab
                    var rowsTotal = this.state.UserList.length;
                    var numPages = Math.ceil(rowsTotal / rowsShown);
                    if (numPages == 1) {

                        $('.nav_in').append('<a href="javascript:;" rel="0">1</a> ');
                        $('.selectbox select').append('<option val="0">1</option> ');
                    }
                    else {
                        for (var i = 0; i < numPages; i++) {
                            var pageNum = i + 1;
                            $('.nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
                            $('.selectbox select').append('<option val="' + i + '">' + pageNum + '</option> ');
                        }
                    }
                    $('#inactive_reps > .userDashData').hide();
                    $('#inactive_reps > .userDashData').slice(0, rowsShown).show();
                    $('.nav_in a').removeClass('active');
                    $('.nav_in a:first').addClass('active');
                    $('.nav_in a').hide();
                    $('.nav_in a').slice(0, maxnoshow).show();
                    $('.nav_in a').bind('click', function () {
                        $('.nav_in a').removeClass('active');
                        $(this).addClass('active');
                        var currPage = $(this).attr('rel');
                        var startItem = currPage * rowsShown;
                        var endItem = startItem + rowsShown;
                        $('#inactive_reps > .userDashData').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
                        if ($(this).attr('rel') != '0') {
                            $('.nav_in a').hide();
                            $(this).prev().show();
                            $(this).show()
                            $(this).next().show();
                            $(this).next().next().show();
                        }
                    });
                    $('.prev-pagination').click(function () {
                        if ($('nav_in .active').attr('rel') != '0') {
                            $('.nav_in .active').prev().addClass('active');
                            $('.nav_in .active').next().removeClass('active');
                            $('.nav_in a').hide();
                            $('.nav_in .active').prev().show();
                            $('.nav_in .active').show()
                            $('.nav_in .active').next().show();
                            $('.nav_in .active').next().next().next().show();
                            let currentPage = $('.nav_in .active').attr('rel');
                            $('.nav_in a').eq(currentPage).click();
                        }
                        if ($('.nav_in .active').attr('rel') == '0') {
                            $('.nav_in a').hide();
                            $('.nav_in .active').show()
                            $('.nav_in .active').next().show();
                            $('.nav_in .active').next().next().show();
                            $('.nav_in .active').next().next().next().show();
                        }
                    });
                    $('.next-pagination').click(function () {
                        $('.nav_in .active').next().addClass('active');
                        $('.nav_in .active').prev().removeClass('active');
                        $('.nav_in a').hide();
                        $('.nav_in .active').prev().show();
                        $('.nav_in .active').show()
                        $('.nav_in .active').next().show();
                        $('.nav_in .active').next().next().show();
                        let currentPage = $('.nav_in .active').attr('rel');
                        $('.nav_in a').eq(currentPage).click();
                    });
                    $('.first_row').click(function () {
                        $('.nav_in a').eq(0).click();
                        $('.nav_in a').hide().removeClass('active');
                        $('.nav_in a:first-child').addClass('active').show();
                        $('.nav_in .active').next().show();
                        $('.nav_in .active').next().next().show();
                        $('.nav_in .active').next().next().next().show();
                    });
                    $('.last_row').click(function () {
                        $('.nav_in a:last-child').click();
                        $('.nav_in a').hide().removeClass('active');
                        $('.nav_in a:last-child').addClass('active').show();
                        $('.nav_in .active').prev().show();
                        $('.nav_in .active').prev().prev().show();
                        $('.nav_in .active').prev().prev().prev().show();
                    });
                    $('.selectbox select').change(function () {
                        var getpage = $(this).val() - 1;
                        $('.nav_in a').eq(getpage).click();
                    });
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleSearchFilter = (e) => {

        try {
            let val = e.target.value.toLowerCase();
            let filtered = $('.table-striped').find('.userDashData');
            $(filtered).filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(val) > -1)
            });
        }
        catch (error) { }
        //try {
        //    let val = $('#SearcInput').val();// e.target.value.toLowerCase();
        //    if (val.length > 0) {
        //        try {
        //            //let filteredArray = JSON.parse(JSON.stringify(this.state.UserList_Temp))
        //            //    .filter((element) =>
        //            //        element.dist.some((subElement) => subElement.username.indexOf('each') !== -1))
        //            //    .map(element => {
        //            //        let newElt = Object.assign({}, element); // copies element
        //            //        return newElt.dist.filter(subElement => subElement.username.indexOf('each') !== '1');
        //            //    });
        //            let data_filter = JSON.parse(JSON.stringify(this.state.UserList_Temp)).filter(function (element) {
        //                return element.dist.some(function (subElement) {
        //                    return subElement.username.toLowerCase().indexOf(val) !== -1 || element.whname.toLowerCase().indexOf(val) !== -1
        //                });
        //            });

        //            this.setState({ UserList: data_filter, SortBy: 'all' });
        //            let s = this.state.UserList;
        //            debugger;
        //        }
        //        catch (error) {
        //        }

        //    }
        //    else {

        //    } this.setState({ UserList: JSON.parse(JSON.stringify(this.state.UserList_Temp)), SortBy: 'all' });
        //}
        //catch (error) { }
    }

    CloseCreatPopup = e => {
        this.setState({ filterId: 1 });
        e.stopPropagation();
        this.setState({
            CreateDashboardPopup: !CreateDashboardPopup, UserName: $(e.target).attr('attname'), UserEmail: $(e.target).attr('attmail'), UserId: $(e.target).attr('attid')
        });
    }

    CloseResendPopup = e => {
        if (this.state.ResendPasswordPopup == false) {
            e.stopPropagation();
            this.setState({
                ResendPasswordPopup: !this.state.ResendPasswordPopup, UserName: $(e.target).parent().parent().find('.second-one')[0].innerText, UserEmail: $(e.target).parent().parent().find('.third-one')[0].innerText, UserId: $(e.target).attr('data-id'), WholesalerName: $(e.target).attr('data-text')
            });
        }
        else {
            e.stopPropagation();
            this.setState({
                ResendPasswordPopup: !this.state.ResendPasswordPopup
            });
        }
    }

    deletePopup = e => {
        if (this.state.DeletePopup == false) {
            e.stopPropagation();
            this.setState({
                DeletePopup: !this.state.DeletePopup, CreateDashboardPopup: !CreateDashboardPopup,
                //UserName: $(e.target).parent().parent().find('.second-one')[0].innerText,
                //UserEmail: $(e.target).parent().parent().find('.third-one')[0].innerText,
                UserName: $(e.target).parents('.userDashData').find('.second-one').eq(0).text(),
                UserEmail: $(e.target).parents('.userDashData').find('.third-one').eq(0).text(),
                UserId: $(e.target).attr('data-id'),
                WholesalerName: $(e.target).attr('data-text')
            });
        }
        else {
            e.stopPropagation();
            this.setState({
                DeletePopup: !this.state.DeletePopup, CreateDashboardPopup: !CreateDashboardPopup
            });
        }

    }
    RemoveDashboardAccount = e => {
        $('#DeletePopupLoader').show();
        $('.searchtextarea').val('');
        e.stopPropagation();
        let UserEmail = this.state.UserEmail;
        let UserName = this.state.UserName;
        let UserId = this.state.UserId;
        let WholeSaler = this.state.WholesalerName;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserEmail, UserName, UserId, WholeSaler })
            };
            return fetch(`/api/user/RemoveWholesalerAccount`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });
                                $(".configure-error").addClass('green');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);

                                this.setState({
                                    ...this.state, DeletePopup: false, UserList: []
                                });
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, DeletePopup: false, UserList: []
                                });
                            }
                        } else {
                            $('.configure-error-content').text('Please try later');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                ...this.state, DeletePopup: false, UserList: []
                            });
                        }
                    }
                    catch (error) {
                        $('.configure-error-content').text('Please try later');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, DeletePopup: false, UserList: []
                        });
                    }
                });
        }
        catch (error) {
        }

    }
    createDashboardPopup = e => {
        let wholesalerName = $(e.target).attr('data-text');
        this.setState({ WholesalerName: wholesalerName });

        e.stopPropagation();
        this.setState({
            CreateDashboardPopup: !this.state.CreateDashboardPopup
        });
    }

    handleConfCreateDashboard = e => {
        this.setState({
            CreateDashboardPopup: !this.state.CreateDashboardPopup
        });

        $('.searchtextarea').val('');
        this.setState({
            loader: true
        });
        let UserEmail = '';
        let UserId = '';
        let UserName = this.state.WholesalerName;
        let WholeSaler = this.state.WholesalerName;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserName, UserEmail, UserId, WholeSaler })
            };
            return fetch(`/api/user/CreateWholesalerDashboard`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });

                                $(".configure-error").addClass('green');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, ResendPasswordPopup: false, UserList: []
                                });
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, ResendPasswordPopup: false, UserList: []
                                });
                            }
                        } else {
                            $('.configure-error-content').text('Please try later');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                ...this.state, ResendPasswordPopup: false, UserList: []
                            });
                        }

                    }
                    catch (error) {
                        $('.configure-error-content').text('Please try later');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, ResendPasswordPopup: false, UserList: []
                        });
                    }
                });
        }
        catch (error) {
        }
    }

    ResendPasswordPopup = (e) => {
        e.stopPropagation();
        this.setState({
            ResendPasswordPopup: !this.state.ResendPasswordPopup,
            UserName: $(e.target).parents('.userDashData').find('.second-one').eq(0).text(),
            UserEmail: $(e.target).parents('.userDashData').find('.third-one').eq(0).text(),
            UserId: $(e.target).attr('data-id'),
            WholesalerName: $(e.target).attr('data-text')
        });
    }
    handleSubmit = e => {
        $('.searchtextarea').val('');
        this.setState({
            loader: true
        });
        let UserEmail = this.state.UserEmail;
        let UserName = this.state.UserName;
        let UserId = this.state.UserId;
        let WholeSaler = this.state.WholesalerName;
        let NewPassword = e[0];
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserEmail, UserName, UserId, WholeSaler, NewPassword })
            };
            return fetch(`/api/user/ResetWhAccountPwd`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });

                                $(".configure-error").addClass('green');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, ResendPasswordPopup: false, UserList: []
                                });
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, ResendPasswordPopup: false, UserList: []
                                });
                            }
                        } else {
                            $('.configure-error-content').text('Please try later');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                ...this.state, ResendPasswordPopup: false, UserList: []
                            });
                        }

                    }
                    catch (error) {
                        $('.configure-error-content').text('Please try later');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, ResendPasswordPopup: false, UserList: []
                        });
                    }
                });
        }
        catch (error) {
        }
    }
    AddUser = e => {
        e.stopPropagation();
        this.setState({
            AddUserPopup: !this.state.AddUserPopup, WholesalerName: $(e.target).attr('data-text')
        });
    }
    handleAdduser = e => {
        $('.searchtextarea').val('');
        this.setState({
            loader: true
        });
        let UserName = e[0];
        let UserEmail = e[1];
        let WholeSaler = this.state.WholesalerName;
        let UserId = '';
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserEmail, UserName, UserId, WholeSaler })
            };
            return fetch(`/api/user/AddWhAccountPwd`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });

                                $(".configure-error").addClass('green');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, AddUserPopup: false, UserList: []
                                });
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, AddUserPopup: false, UserList: []
                                });
                            }
                        } else {
                            $('.configure-error-content').text('Please try later');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                ...this.state, AddUserPopup: false, UserList: []
                            });
                        }

                    }
                    catch (error) {
                        $('.configure-error-content').text('Please try later');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, AddUserPopup: false, UserList: []
                        });
                    }
                });
        }
        catch (error) {
        }
    }

    withDashboard = e => {
        $('.tabs a').removeClass('active');
        $('.tabs a').eq(1).addClass('active');
        this.setState({
            UserList: [], SortBy: 'withdashboard', loader: true
        });
    }
    withoutDashboard = e => {
        $('.tabs a').removeClass('active');
        $('.tabs a').eq(2).addClass('active');
        this.setState({
            UserList: [], SortBy: 'withoutdashboard', loader: true
        });
    }
    allDashboard = e => {
        $('.tabs a').removeClass('active');
        $('.tabs a').eq(0).addClass('active');
        this.setState({
            UserList: [], SortBy: 'all', loader: true
        });
    }


    render() {
        return (
            <div className='popup manage-user manage-user-admin'>
                <div className='popup_inner'>
                    <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                    <div className="WhCommission">
                        { 
                            this.state.UserList.length == 0 ?
                                <div className="theme-loader"></div> : null
                        }
                    </div>
                    {this.state.loader ? (
                        <div className="theme-loader"></div>
                    ) : null
                    }
                    <div className="populate">
                        <input type="text" className="form-control searchTable searchtextarea" id="SearcInput" autocomplete="off" name="searchtext" placeholder="Search for a User" onKeyUp={this.handleSearchFilter} />
                    </div>
                    {this.state.containerHide ? (
                        <div className="user-content">
                            <div className="tabs">
                                <a href="javascript:void('0')" onClick={this.allDashboard} className="first active">All</a>
                                <a href="javascript:void('0')" onClick={this.withDashboard}>With Dashboard</a>
                                <a href="javascript:void('0')" onClick={this.withoutDashboard} className="last">Without Dashboard</a>
                            </div>
                            <h3>List of Users</h3>
                            <div className="scroll-user">
                                <div className="scroll-user-scroll">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th className="first-one">Sr. No.</th>
                                                <th className="second-one">Wholesaler Name</th>
                                                <th className="fourth-one">Action</th>
                                            </tr>
                                        </thead>
                                        {
                                            this.state.UserList != null && this.state.UserList.length > 0 ?
                                                <tbody id="inactive_reps">
                                                    {
                                                        this.state.UserList.map((e1, i1) => {
                                                            if (e1.dashid == "0" && e1.dashstatus == "No dashboard exits") {
                                                                return (
                                                                    <tr className="userDashData createDashboardIcon">
                                                                        <td className="first-one">{i1 + 1}</td>
                                                                        <td className="second-one">{e1.whname}</td>
                                                                        <td className="fourth-one">
                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img data-text={e1.whname} onClick={this.createDashboardPopup.bind(this)} src={CreateDashboardIcon} className="CreateDashboardIcon" alt="dashboardIcon" /><span className="hover-tooltip createNew">Create New Dashboard</span></a>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                            else if (e1.dashstatus != "0" && e1.dashstatus == "Dashboard exits without user") {
                                                                return (
                                                                    <tr className="userDashData createDashboardIcon">
                                                                        <td className="first-one">{i1 + 1}</td>
                                                                        <td className="second-one">{e1.whname}</td>
                                                                        <td className="fourth-one">
                                                                            <span className="plus-sign" onClick={this.handleSlideToggle}>Plus</span>
                                                                        </td>
                                                                        <td className="subUser toggle-Content">
                                                                            <tr className="userDashData createDashboardIcon">
                                                                                <td className="first-one">&nbsp;</td>
                                                                                <td className="second-one">Add New User</td>
                                                                                <td className="fourth-one">
                                                                                    <span className="add-user-btn" onClick={this.AddUser}><img data-text={e1.whname} src={User} className="CreateDashboardIcon" alt="dashboardIcon" /></span>
                                                                                </td>
                                                                            </tr>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    <tr className="userDashData createDashboardIcon">
                                                                        <td className="first-one">{i1 + 1}</td>
                                                                        <td className="second-one">{e1.whname}</td>
                                                                        <td className="fourth-one">
                                                                            <span className="plus-sign" onClick={this.handleSlideToggle}>Plus</span>
                                                                        </td>
                                                                        <td className="subUser toggle-Content">
                                                                            {
                                                                                this.state.UserList[i1]["dist"].map((e2, i2) => {

                                                                                    return (
                                                                                        <tr className="userDashData createDashboardIcon">
                                                                                            <td className="first-one">&nbsp;</td>
                                                                                            <td className="second-one">{e2.username}</td>
                                                                                            <td className="third-one">{e2.useremail}</td>
                                                                                            <td className="fourth-one">
                                                                                                <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.ResendPasswordPopup.bind(this)} data-id={e2.userid} data-text={e1.whname} className="changePasswordIcon" src={ResendPassword} alt="ResendPasswordIcon" /><span className="hover-tooltip createNew">Change Password</span></a>
                                                                                                <a href="javascript:void('0')" className="custom-tooltip"><img className="deleteIcon" data-id={e2.userid} data-text={e1.whname} onClick={this.deletePopup.bind(this)} src={DeleteIcon} alt="deleteIcon" /><span className="hover-tooltip deleteDash">Delete Dashboard</span></a>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                            <tr className="userDashData createDashboardIcon">
                                                                                <td className="first-one">&nbsp;</td>
                                                                                <td className="second-one">Add New User</td>
                                                                                <td className="fourth-one">
                                                                                    <span className="add-user-btn" data-text={e1.whname} onClick={this.AddUser}><a href="javascript:void('0')" className="custom-tooltip"><img data-text={e1.whname} src={User} className="CreateDashboardIcon" alt="dashboardIcon" /><span className="hover-tooltip createNew">Create Dashboard</span></a></span>
                                                                                </td>
                                                                            </tr>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tbody> : null
                                        }
                                    </table>
                                </div>
                            </div>
                            {
                                this.state.DeletePopup ?
                                    <ConfirmDeleteAdminPopup handleCondition={this.RemoveDashboardAccount.bind(this)} DeleteSection={this.state.DeleteSection} titleText="Are you sure want to delete this dashboard?" closePopup={this.deletePopup.bind(this)} /> : null
                            }
                            {
                                this.state.AddUserPopup ?
                                    <AddUserPopup titleText="Add User" handleDashboard={this.handleAdduser.bind(this)} closePopup={this.AddUser.bind(this)} /> : null
                            }
                            {
                                this.state.CreateDashboardPopup ?
                                    <ConfirmDeleteAdminPopup handleConfirmCreate={this.handleConfCreateDashboard.bind(this)} currentWholesalerName={this.state.WholesalerName} titleText="Click on confirm to add a dashboard" CloseCreatPopup={this.CloseCreatPopup.bind(this)} /> : null
                            }
                            {
                                this.state.ResendPasswordPopup ?
                                    <ConfirmDeleteAdminPopup ResendPasswordSection={this.state.ResendPasswordSection} handleSubmit={this.handleSubmit.bind(this)} titleText="Change Password" closeResendPopup={this.CloseResendPopup.bind(this)} /> : null
                            }
                            <div className="pagination">
                                <div className="selectbox">
                                    Jump to
                                            <select></select>
                                </div>
                                <a href="javascript:;" className="first_row">First</a>
                                <a className="prev-pagination" href="javascript:;"></a>
                                <div className="nav_in">
                                </div>
                                <a className="next-pagination" href="javascript:;"></a>
                                <a href="javascript:;" className="last_row">Last</a>
                            </div>

                        </div>
                    ) : null
                    }

                    <div className="configure-error">
                        <span className="configure-close"></span>
                        <div className="left">
                            {
                                this.state.OpStatus ?
                                    <img src={Success} alt="Success" /> :
                                    <img src={Error} alt="error" />
                            }

                        </div>
                        <div className="right">
                            <h3 className="configure-heading"></h3>
                            <ul className="configure-error-list">
                                <li className="configure-error-content">&nbsp;</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div >
        );
    }
}
export default ManageUser;